import { render, staticRenderFns } from "./BuscarPedidoDialog.vue?vue&type=template&id=23c7de50"
import script from "./BuscarPedidoDialog.vue?vue&type=script&lang=js"
export * from "./BuscarPedidoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports